import React, {
    Component
} from 'react';
import {
    connect
} from 'react-redux'
import {
    map,
    toUpper
} from 'lodash-es'

import SelectedItem from './SelectedItem'

import {
    getSelectedState,
    getPrices
} from '../selectors/index'

class Overview extends Component {

    getOptionList = (categories) => {
        let optionList = "";

        for(const cat in categories){
            optionList += categories[cat].title + ":\n";
            if (categories[cat].options.length) {
                for(const opt in categories[cat].options){
                    optionList += categories[cat].options[opt].description + "\n";
                }
            } else {
                optionList += "-\n";
            }
            optionList += "--------------\n";
        }
        return optionList;
    };

    componentDidMount() {
        const {categories} = this.props;
        if(typeof window.boatConfiguration !== 'undefined' && window.boatConfiguration !== null) {
            window.boatConfiguration = this.getOptionList(categories);
        }
    }

    componentDidUpdate() {
        const {categories} = this.props;
        if(typeof window.boatConfiguration !== 'undefined' && window.boatConfiguration !== null) {
            window.boatConfiguration = this.getOptionList(categories);
        }
    }

    renderSelections = (selections, property) => {
        const {translations} = this.props;
        if (selections.length) {
            return (
                <div><SelectedItem property={property} showIcon={false} className="overview-selected-item"/></div>
            )
        }else{
            return(
              <div className="overview-empty">
                  <span>{translations['overview-no-option-selected']}</span>
                  <a href={`#${property}`} className="goto-view-options">{translations['overview-view-options']}</a>
              </div>
            )
        }
    };

    renderCategory = (category, property) => {
        const {options, title = toUpper(property)} = category;
        return (
            <div key={property}>
                <h4 className="overview-section-title">{title}</h4>
                {this.renderSelections(options, property)}
                <hr/>
            </div>
        )
    };

    render() {
        const {categories} = this.props;
        return (
            <div>
                {map(categories, this.renderCategory)}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    categories: getSelectedState(state),
    boat: state.boat,
    prices: getPrices(state),
    translations: state.translations
});

export default connect(mapStateToProps)(Overview);



// WEBPACK FOOTER //
// ./src/components/Overview.js